import m from "../../geodata/es2015/swedenHigh";
window.am4geodata_swedenHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/swedenHigh.js
// module id = null
// module chunks = 